// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { ProceedState } from "@/types/proceed";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Proceed } from "@/models/proceed";

const state: ProceedState = {
  single: new Proceed(),
  pagination: new Pagination(),
};

export const proceed: Module<ProceedState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
